import React, { useState, useEffect } from "react";
import { useTheme } from "../components/ThemeContext";
import {
  Navbar,
  Nav,
  Image,
  Container,
  Dropdown,
  Modal,
  Button,
} from "react-bootstrap";
import {
  IoSettingsOutline,
  IoNotificationsOutline,
  IoExitOutline,
} from "react-icons/io5";
import { CiViewList } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import "../App.css";
import "react-toastify/dist/ReactToastify.css";
import { MdSpaceDashboard } from "react-icons/md";
import { FaBell } from "react-icons/fa";
import { HiDocumentMagnifyingGlass } from "react-icons/hi2";
import { PiListChecksFill } from "react-icons/pi";
import { BsFillFileBarGraphFill } from "react-icons/bs";
import { HiDocumentDuplicate } from "react-icons/hi2";
import { PiSignatureBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { IoMdMoon } from "react-icons/io";
import { HiSun } from "react-icons/hi";

const NavMenu = () => {
  const lightlogo = require("../img/eaim_logo_only_purple.png");
  const darklogo = require("../img/eaim_logo_only_w.png");
  const profile = require("../img/profile.png");
  const [user, setUser] = useState({
    user_name: "",
    description: "",
    role: "",
    id: "",
  });
  const [description, setDescription] = useState("");
  const [showAppraisalModal, setShowAppraisalModal] = useState(false);
  const [appraisalName, setAppraisalName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [settings, setSettings] = useState({
    email: true,
    whatsapp: false,
    teams: false,
  });
  const { isDark, toggleTheme } = useTheme();

  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    document.body.className = theme + "-theme";
    localStorage.setItem("theme", theme);
  }, [isDark]);

  useEffect(() => {
    const loggedInUser = JSON.parse(localStorage.getItem("user"));
    if (loggedInUser) {
      setUser(loggedInUser);
      setDescription(loggedInUser.description);
    }
  }, []);

  const navigate = useNavigate();

  const currentDate = new Date().toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const handleLogout = () => {
    navigate("/login");
  };

  const handleSaveAppraisal = async () => {
    if (!appraisalName) {
      alert("Please enter the appraisal name.");
      return;
    }

    if (!isConfirmation && (!startDate || !dueDate)) {
      alert("Please fill in the start and due date.");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No auth token found in localStorage");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/createAppraisal`,
        {
          appraisal_name: appraisalName,
          start_date: startDate,
          due_date: dueDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        alert("Appraisal created successfully!");
        setShowAppraisalModal(false);
        setAppraisalName("");
        setStartDate("");
        setDueDate("");
      } else {
        alert(response.data.message || "Failed to create appraisal.");
      }
    } catch (error) {
      console.error("Appraisal creation failed:", error);
      alert("Server error. Please try again.");
    }
  };

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        fixed="top"
        className="shadow-sm py-2 px-3"
      >
        <Container fluid>
          <Navbar.Brand
            href={
              user.description === "HR"
                ? "/hr-dashboard"
                : user.role === "Staff"
                ? "/my-appraisal"
                : "/sup-dashboard"
            }
            className="d-flex align-items-center gap-3"
          >
            <Image src={isDark ? darklogo : lightlogo} width="80" alt="Logo" />
            <span
              className="ms-2 d-none d-md-inline"
              style={{ fontSize: "22px", color: isDark ? "#fff" : "grey" }}
            >
              Staff Performance Appraisal
            </span>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto align-items-center gap-3">
              <Button
                variant="light"
                onClick={toggleTheme}
                className="d-flex align-items-center justify-content-center p-1 rounded-circle border-0"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: isDark ? "#2c3e50" : "#f1c40f",
                  color: isDark ? "#fff" : "#000",
                }}
                title={`Switch to ${isDark ? "Dark" : "Light"} Mode`}
              >
                {isDark ? <IoMdMoon size={18} /> : <HiSun size={25} />}
              </Button>

              <Nav.Link
                className="p-0"
                style={{ color: isDark ? "#ffffff" : "#212529" }}
                onClick={() => setShowSettingsModal(true)}
              >
                <IoSettingsOutline size={22} />
              </Nav.Link>

              <Nav.Link
                className="p-0"
                style={{ color: isDark ? "#ffffff" : "#212529" }}
              >
                <IoNotificationsOutline size={22} />
              </Nav.Link>

              <Nav.Link
                className="p-0"
                style={{ color: isDark ? "#ffffff" : "#212529" }}
                onClick={handleLogout}
              >
                <IoExitOutline size={22} />
              </Nav.Link>

              <div
                style={{
                  fontSize: "14px",
                  color: isDark ? "#ffffff" : "#212529",
                }}
              >
                <strong>{user.user_name}</strong> ({description})
              </div>

              {/* Profile Dropdown */}
              <Dropdown align="end">
                <Dropdown.Toggle variant="link" className="p-0 border-0">
                  <Image src={profile} width="36" alt="Profile" roundedCircle />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className={isDark ? "bg-dark border-secondary" : ""}
                  style={{
                    backgroundColor: isDark ? "#2c2c2c" : "#fff",
                    color: isDark ? "#fff" : "#000",
                  }}
                >
                  {user.description === "HR" && (
                    <Dropdown.Item
                      onClick={() => setShowAppraisalModal(true)}
                      className={isDark ? "text-light" : ""}
                      style={{
                        backgroundColor: isDark ? "#2c2c2c" : "#fff",
                      }}
                    >
                      <CiViewList className="me-2" /> Appraisal
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item
                    onClick={() => navigate("/signature")}
                    className={isDark ? "text-light" : ""}
                    style={{
                      backgroundColor: isDark ? "#2c2c2c" : "#fff",
                    }}
                  >
                    <PiSignatureBold className="me-2" /> Signature
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div
        className="secondary-nav-desktop d-none d-md-block px-3 py-2"
        style={{
          marginTop: "60px",
          backgroundColor: isDark ? "#2c3e50" : "#d9d9d9",
          color: isDark ? "#fff" : "#000",
          fontSize: "14px",
        }}
      >
        <Container fluid>
          <div className="d-flex flex-wrap align-items-center gap-4">
            {user.description === "HR" ? (
              <>
                <NavLink
                  to="/hr-dashboard"
                  className={({ isActive }) =>
                    `text-decoration-none ${
                      isActive
                        ? "active-color fw-bold"
                        : `${isDark ? "text-secondary" : "text-dark"}`
                    }`
                  }
                >
                  Dashboard
                </NavLink>

                <NavLink
                  to="/sup-dashboard"
                  className={({ isActive }) =>
                    `text-decoration-none ${
                      isActive
                        ? "active-color fw-bold"
                        : `${isDark ? "text-secondary" : "text-dark"}`
                    }`
                  }
                >
                  Team Overview
                </NavLink>
              </>
            ) : user.role !== "Staff" ? (
              <NavLink
                to="/sup-dashboard"
                className={({ isActive }) =>
                  `text-decoration-none ${
                    isActive
                      ? "active-color fw-bold"
                      : `${isDark ? "text-secondary" : "text-dark"}`
                  }`
                }
              >
                Manager Dashboard
              </NavLink>
            ) : null}

            {(user.description === "HR" || user.description === "MIS") && (
              <>
                <NavLink
                  to="/appraisal-assessment"
                  className={({ isActive }) =>
                    `text-decoration-none ${
                      isActive
                        ? "active-color fw-bold"
                        : `${isDark ? "text-secondary" : "text-dark"}`
                    }`
                  }
                >
                  Form Creation
                </NavLink>
                <NavLink
                  to="/remind-appraisal"
                  className={({ isActive }) =>
                    `text-decoration-none ${
                      isActive
                        ? "active-color fw-bold"
                        : `${isDark ? "text-secondary" : "text-dark"}`
                    }`
                  }
                >
                  Form Distribution
                </NavLink>

                <NavLink
                  to="/reporting"
                  className={({ isActive }) =>
                    `text-decoration-none ${
                      isActive
                        ? "active-color fw-bold"
                        : `${isDark ? "text-secondary" : "text-dark"}`
                    }`
                  }
                >
                  Reporting & Analytics
                </NavLink>
              </>
            )}

            {user?.role !== "Staff" && (
              <NavLink
                to="/view-appraisal"
                className={({ isActive }) =>
                  `text-decoration-none ${
                    isActive
                      ? "active-color fw-bold"
                      : `${isDark ? "text-secondary" : "text-dark"}`
                  }`
                }
              >
                View Appraisal Forms
              </NavLink>
            )}

            <NavLink
              to="/my-appraisal"
              className={({ isActive }) =>
                `text-decoration-none ${
                  isActive
                    ? "active-color fw-bold"
                    : `${isDark ? "text-secondary" : "text-dark"}`
                }`
              }
            >
              My Appraisal
            </NavLink>

            <NavLink
              to="/history"
              className={({ isActive }) =>
                `text-decoration-none ${
                  isActive
                    ? "active-color fw-bold"
                    : `${isDark ? "text-secondary" : "text-dark"}`
                }`
              }
            >
              Appraisal Tracking
            </NavLink>

            <div
              className="ms-auto mt-2 mt-md-0"
              style={{ color: isDark ? "text-light" : "text-dark" }}
            >
              <small>Last Login: </small>
              {currentDate}
            </div>
          </div>
        </Container>
      </div>

      {/* Mobile Bottom Navigation (Icons Only) */}
      <div
        className="bottom-nav-mobile d-md-none"
        style={{ marginTop: "60px" }}
      >
        <Nav className="d-flex justify-content-around py-2 bg-light shadow fixed-bottom">
          {user.description === "HR" ? (
            <NavLink
              to="/hr-dashboard"
              className={({ isActive }) =>
                `text-center small d-flex flex-column align-items-center text-decoration-none ${
                  isActive ? "mobile-nav-active" : "text-dark"
                }`
              }
            >
              <MdSpaceDashboard size={20} />
              <span className="mt-1" style={{ fontSize: "11px" }}>
                Dashboard
              </span>
            </NavLink>
          ) : (
            <NavLink
              to="/sup-dashboard"
              className={({ isActive }) =>
                `text-center small d-flex flex-column align-items-center text-decoration-none ${
                  isActive ? "mobile-nav-active" : "text-dark"
                }`
              }
            >
              <MdSpaceDashboard size={20} />
              <span className="mt-1" style={{ fontSize: "11px" }}>
                Dashboard
              </span>
            </NavLink>
          )}

          {user.description === "HR" && (
            <>
              <NavLink
                to="/remind-appraisal"
                className={({ isActive }) =>
                  `text-center small d-flex flex-column align-items-center text-decoration-none ${
                    isActive ? "mobile-nav-active" : "text-dark"
                  }`
                }
              >
                <FaBell />
                <span className="mt-1" style={{ fontSize: "11px" }}>
                  Remind
                </span>
              </NavLink>

              <NavLink
                to="/appraisal-assessment"
                className={({ isActive }) =>
                  `text-center small d-flex flex-column align-items-center text-decoration-none ${
                    isActive ? "mobile-nav-active" : "text-dark"
                  }`
                }
              >
                <PiListChecksFill />
                <span className="mt-1" style={{ fontSize: "11px" }}>
                  Management
                </span>
              </NavLink>
              <NavLink
                to="/reporting"
                className={({ isActive }) =>
                  `text-center small d-flex flex-column align-items-center text-decoration-none ${
                    isActive ? "mobile-nav-active" : "text-dark"
                  }`
                }
              >
                <BsFillFileBarGraphFill />
                <span className="mt-1" style={{ fontSize: "11px" }}>
                  Reports
                </span>
              </NavLink>
              <NavLink
                to="/history"
                className={({ isActive }) =>
                  `text-center small d-flex flex-column align-items-center text-decoration-none ${
                    isActive ? "mobile-nav-active" : "text-dark"
                  }`
                }
              >
                <HiDocumentDuplicate />
                <span className="mt-1" style={{ fontSize: "11px" }}>
                  History
                </span>
              </NavLink>
            </>
          )}

          <NavLink
            to="/view-appraisal"
            className={({ isActive }) =>
              `text-center small d-flex flex-column align-items-center text-decoration-none ${
                isActive ? "mobile-nav-active" : "text-dark"
              }`
            }
          >
            <HiDocumentMagnifyingGlass />
            <span className="mt-1" style={{ fontSize: "11px" }}>
              View
            </span>
          </NavLink>
        </Nav>
      </div>

      <Modal
        show={showAppraisalModal}
        onHide={() => setShowAppraisalModal(false)}
        centered
      >
        <Modal.Header
          className={isDark ? "bg-dark text-light border-secondary" : ""}
          closeButton
        >
          <Modal.Title>Appraisal Information</Modal.Title>
        </Modal.Header>
        <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <label className="form-label fw-bold mb-0">Appraisal Name</label>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="confirmationCheckbox"
                  checked={isConfirmation}
                  onChange={(e) => setIsConfirmation(e.target.checked)}
                />
                <label
                  className="form-check-label"
                  htmlFor="confirmationCheckbox"
                >
                  Confirmation
                </label>
              </div>
            </div>
            <input
              type="text"
              className={`form-control ${
                isDark ? "bg-dark text-light border-secondary" : ""
              }`}
              placeholder="Enter Appraisal Name"
              value={appraisalName}
              onChange={(e) => setAppraisalName(e.target.value)}
              style={{
                backgroundColor: isDark ? "#2c2c2c" : "#fff",
                color: isDark ? "#fff" : "#000",
                borderColor: isDark ? "#555" : "#ced4da",
              }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                backgroundColor: isDark ? "#2c2c2c" : "#fff",
                color: isDark ? "#fff" : "#000",
                borderColor: isDark ? "#555" : "#ced4da",
              }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Due Date</label>
            <input
              type="date"
              className="form-control"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              style={{
                backgroundColor: isDark ? "#2c2c2c" : "#fff",
                color: isDark ? "#fff" : "#000",
                borderColor: isDark ? "#555" : "#ced4da",
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className={isDark ? "bg-dark border-secondary" : ""}>
          <button
            className="btn btn-secondary"
            onClick={() => setShowAppraisalModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn"
            onClick={handleSaveAppraisal}
            style={{ background: "#B31E8D", color: "white" }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSettingsModal}
        onHide={() => setShowSettingsModal(false)}
        centered
      >
        <Modal.Header
          closeButton
          className={isDark ? "bg-dark text-light border-secondary" : ""}
        >
          <Modal.Title>Notification Preferences</Modal.Title>
        </Modal.Header>

        <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="emailCheckbox"
              checked={settings.email}
              disabled
              onChange={() =>
                setSettings((prev) => ({ ...prev, email: !prev.email }))
              }
            />
            <label
              className={`form-check-label ${isDark ? "text-light" : ""}`}
              htmlFor="emailCheckbox"
            >
              Email (Mandatory)
            </label>
          </div>

          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="whatsappCheckbox"
              checked={settings.whatsapp}
              onChange={() =>
                setSettings((prev) => ({ ...prev, whatsapp: !prev.whatsapp }))
              }
            />
            <label
              className={`form-check-label ${isDark ? "text-light" : ""}`}
              htmlFor="whatsappCheckbox"
            >
              WhatsApp
            </label>
          </div>

          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="teamsCheckbox"
              checked={settings.teams}
              onChange={() =>
                setSettings((prev) => ({ ...prev, teams: !prev.teams }))
              }
            />
            <label
              className={`form-check-label ${isDark ? "text-light" : ""}`}
              htmlFor="teamsCheckbox"
            >
              Microsoft Teams
            </label>
          </div>
        </Modal.Body>

        <Modal.Footer className={isDark ? "bg-dark border-secondary" : ""}>
          <button
            className={`btn btn-secondary`}
            onClick={() => setShowSettingsModal(false)}
          >
            Close
          </button>
          <button
            className="btn"
            onClick={() => {
              console.log("Selected settings:", settings);
              setShowSettingsModal(false);
            }}
            style={{ background: "#B31E8D", color: "white" }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NavMenu;
